export function getApiLink(str: string): string {
    const s = (str || '').trim();
    if (!s) return '';

    // Нормалізуємо шлях - видаляємо зайві /api на початку
    let normalized = s.startsWith('/') ? s : '/' + s;
    
    // Якщо шлях починається з /api/, видаляємо цей префікс
    // бо він буде доданий пізніше
    if (normalized.startsWith('/api/')) {
        normalized = normalized.slice(4); // видаляємо "/api"
    }

    // If it's a media file served at the root, keep it as-is (e.g., /media/...)
    if (normalized.startsWith('/media')) {
        return normalized;
    }

    const base = (process.env.REACT_APP_API_URL || '').trim();

    if (base) {
        // Ensure no trailing slash on base
        const normalizedBase = base.replace(/\/$/, '');
        return normalizedBase + normalized;
    }

    // Default to local proxy path served by frontend nginx in docker-compose
    return '/api' + normalized;
}